import { Link } from "react-router-dom";

export const EducationRemotelyConst = {
  path: "/single-page/education-remotely",
  title: "Дистанционное образование",
  contentJSX: (
    <>
      <h2>ДИСТАНЦИОННАЯ (ОНЛАЙН) ФОРМА ОБУЧЕНИЯ В MALTA SCHOOL OF MEDICINE & BUSINESS</h2>
      <p>
        Получите европейское образование, не покидая свой город — учитесь из любой точки мира, в удобное для вас время, и получайте диплом,
        признанный в странах ЕС и СНГ. <strong>Дистанционное обучение</strong> — это современное решение для тех, кто ценит свободу,
        гибкость и международные возможности.
      </p>
      <h2>ОСОБЕННОСТИ ДИСТАНЦИОННОГО ОБУЧЕНИЯ:</h2>
      <ul>
        <li>
          Одинаковая программа и диплом — вы проходите ту же академическую программу, что и студенты очной формы. Диплом MSMB имеет такую же
          юридическую силу.
        </li>
        <li>
          Гибкое расписание — занятия адаптированы под студентов из разных часовых поясов. Вы можете учиться утром, днём или вечером,
          совмещая учебу с работой, семьей или другими делами.
        </li>
        <li>
          Доступ к образовательной платформе — вы получаете доступ к Zoom-лекциям, тестам, учебным пособиям, электронным библиотекам и
          форумам.
        </li>
        <li>
          Поддержка преподавателей — обратная связь, онлайн-консультации, наставничество и совместная работа над проектами обеспечивают
          высокое качество взаимодействия.
        </li>
        <li>Экономия времени и средств — не нужно тратить деньги на поездки, визу, проживание и питание за границей.</li>
      </ul>
      <h2>ПОДХОДИТ ТЕМ, КТО:</h2>
      <ul>
        <li>Хочет получить международный диплом, не покидая родную страну;</li>
        <li>Предпочитает учиться в привычной обстановке — дома или в офисе;</li>
        <li>Уже работает или заботится о семье, но мечтает о развитии и новых возможностях;</li>
        <li>Не готов к переезду, но хочет учиться у европейских преподавателей;</li>
        <li>Планирует продолжить карьеру или обучение за рубежом в будущем.</li>
      </ul>
      <p>Дистанционное обучение — это свобода, комфорт и признанный результат без границ.</p>
      <p>Станьте частью международного академического сообщества уже сейчас — не выходя из дома.</p>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    ДИСТАНЦИОННАЯ (ОНЛАЙН) ФОРМА ОБУЧЕНИЯ В MALTA SCHOOL OF MEDICINE & BUSINESS

    Получите европейское образование, не покидая свой город — учитесь из любой точки мира, в удобное для вас время, и получайте диплом, признанный в странах ЕС и СНГ. Дистанционное обучение — это современное решение для тех, кто ценит свободу, гибкость и международные возможности.

    ОСОБЕННОСТИ ДИСТАНЦИОННОГО ОБУЧЕНИЯ:

    Одинаковая программа и диплом — вы проходите ту же академическую программу, что и студенты очной формы. Диплом MSMB имеет такую же юридическую силу.
    Гибкое расписание — занятия адаптированы под студентов из разных часовых поясов. Вы можете учиться утром, днём или вечером, совмещая учебу с работой, семьей или другими делами.
    Доступ к образовательной платформе — вы получаете доступ к Zoom-лекциям, тестам, учебным пособиям, электронным библиотекам и форумам.
    Поддержка преподавателей — обратная связь, онлайн-консультации, наставничество и совместная работа над проектами обеспечивают высокое качество взаимодействия.
    Экономия времени и средств — не нужно тратить деньги на поездки, визу, проживание и питание за границей.

    ПОДХОДИТ ТЕМ, КТО:

    Хочет получить международный диплом, не покидая родную страну;
    Предпочитает учиться в привычной обстановке — дома или в офисе;
    Уже работает или заботится о семье, но мечтает о развитии и новых возможностях;
    Не готов к переезду, но хочет учиться у европейских преподавателей;
    Планирует продолжить карьеру или обучение за рубежом в будущем.

    Дистанционное обучение — это свобода, комфорт и признанный результат без границ.

    Станьте частью международного академического сообщества уже сейчас — не выходя из дома.
  `,
};
